import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Tab_01 from "../../images/services/da/Data-Engineering.webp";
import Tab_02 from "../../images/services/da/Big-Data-Analytics.webp";
import Tab_03 from "../../images/services/da/Data-Monetization.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Our Forte</h2>
                            </div>
                            <p>Transforming the decision-making process</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>274B
                                        <span>Approx. Market Size</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>2.5M
                                        <span>Daily Data Production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Data Engineering</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Big Data Analytics</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Data Monetization</div>
                            </h3>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Data Engineering</h2>
                                <p>Our data engineering solutions provide our clients with extensive big data analytics
                                    services, including data warehousing, data lake solutions, and extract, transform
                                    and load (ETL) development solutions. We take care of all the issues by forming data
                                    pipelines and transforming raw data into usable datasets to be used for various
                                    purposes.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_01}
                                    effect="blur" alt="Tab_01" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Big Data Analytics</h2>
                                <p>Leveraging the business intelligence tools and big data analytics, we bring insights
                                    you haven’t seen before. We extract results to provide your business with the
                                    breakthrough you have been looking for. Using multiple technologies, including data
                                    science and machine learning, we provide precise data analytics for more efficient
                                    outcomes for your business.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_02}
                                    effect="blur" alt="Tab_02" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Data Monetization</h2>
                                <p>Data is the new currency for organizations and governments around the globe. We
                                    assist you in optimizing your business performance by accessing rare insights based
                                    on the data. With data, you get the chance to build better customer relations and
                                    identify better growth opportunities. TekRevol’s data monetization services have got
                                    you covered.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_03}
                                    effect="blur" alt="Tab_03" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

export default Technologysec;